// Module
var code = "<div fg-property-field-common=\"{ fieldname: true, displayname: true, placeholder: true, tooltip: false, previousfield: true }\"></div> <div class=\"properties-validation\"> <div fg-property-field-validation=\"{ required: false}\"></div> </div> ";
// Exports
export default code;